import { convertFromQueryToNewUiFormat } from '@hotjar/global-filters';
import { DEFAULT_SEGMENT } from '@hotjar/webapp/domains/segments/constant';
import { addViewParamToUrl, removeViewParamFromUrl } from './overviewParam';
import { updateFilterAndUrl } from './updateFilterAndUrl';
import type { Store } from '../../../store/list/types';

export const toggleRecordingsView = (
  store: Store,
  isOverviewVisible: boolean,
  enableFilterInteraction: () => void,
  resetFilterInteraction: () => void,
): void => {
  if (isOverviewVisible) {
    openList(enableFilterInteraction);
  } else {
    openOverview(store, resetFilterInteraction);
  }
};

export const openList = (openListCallback: () => void): void => {
  // Reset filter when going to overview
  addViewParamToUrl('list');
  openListCallback();
};

const openOverview = (store: Store, openOverviewCallback: () => void) => {
  // Show Overview
  const { effectiveDateRangeFilter } = store.getState();
  const defaulFilters = effectiveDateRangeFilter || DEFAULT_SEGMENT.filters;
  removeViewParamFromUrl();

  // Reset filter when going to overview
  updateFilterAndUrl(store, convertFromQueryToNewUiFormat(defaulFilters));
  openOverviewCallback();
};
